import { StandardsLoadingSpinner } from "./StandardsLoadingSpinner.component";

export { StandardsLoadingSpinner };
